import React, { useEffect, useMemo, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import bg from "../assets/hero.png";
import { Buttons } from "../components/Buttons";
import Topbar from "../components/Topbar";

import Fragrances from "../components/Home/Fragrances";
import Brands from "../components/Home/Brands";
import Categories from "../components/Home/Categories";
import Poster from "../components/Home/Poster";
import Promo from "../components/Home/Salespromo4"; // Your latest promo component
import Feed from "../components/Home/Feed";
import Salespromo from "../components/Home/Salespromo"; // Fixed import
import Featured from "../components/Home/Featured"; // Fixed import

import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../redux/api/products";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useNavigate } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Refs for Hero Animation
  const heroRef = useRef(null);
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const btnRef = useRef(null);

  const { allProducts, loading } = useSelector((state) => state.products);
  console.log(allProducts);
  // Fetch only if not already loaded — cache-safe
  useEffect(() => {
    if (!allProducts?.length) {
      dispatch(fetchProducts());
    }
  }, []);

  const menProducts = useMemo(() => {
    return allProducts?.filter((p) =>
      p.tags?.some((tag) => tag.trim().toLowerCase() === "men"),
    );
  }, [allProducts]);

  const womenProducts = useMemo(() => {
    return allProducts?.filter((p) =>
      p.tags?.some((tag) => tag.trim().toLowerCase() === "women"),
    );
  }, [allProducts]);
  const handleButtonClick = () => {
    navigate("/fragrance");
  };
  return (
    <>
      <Topbar />

      {/* HERO SECTION */}
      <div
        ref={heroRef}
        className="relative min-h-[680px] h-screen bg-cover bg-[80%] bg-no-repeat overflow-hidden bg-[#00000042] bg-blend-overlay"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <Navbar />

        <div
          className="container"
          style={{
            maxWidth: "1440px",
            margin: "0 auto",
            padding: "0 24px",
            height: "100%",
          }}
        >
          <div className="max-w-[1840px] mx-auto px-0 sm:px-6 h-full flex items-center">
            <div className="max-w-2xl pt-16 sm:pt-0">
              <h4 className="font-gopher text-white tracking-[3px] sm:tracking-[4px] text-sm sm:text-lg mb-4">
                New Arrivals!
              </h4>

              <h1
                ref={titleRef}
                className="text-white text-[clamp(2.6rem,11vw,5.5rem)] leading-[0.95] font-bold max-w-[700px]"
              >
                Unleash Your Signature Scent
              </h1>

              <p
                ref={subtitleRef}
                className="text-white/90 text-lg sm:text-xl md:text-2xl mt-5 sm:mt-6 mb-8 sm:mb-10 font-light"
              >
                Pour Femme & Blossomy
              </p>

              <div ref={btnRef}>
                <Buttons
                  handleClick={() => handleButtonClick()}
                  title="Shop Now"
                  className="font-gopher text-lg px-10 py-4"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sections with Scroll Animation */}
      <div className="animate-section">
        <Salespromo />
      </div>

      <div className="animate-section">
        <Fragrances title="Men Fragrances" products={allProducts} />
      </div>

      <div className="animate-section">
        <Brands />
      </div>

      <div className="animate-section">
        <Poster />
      </div>

      <div className="animate-section">
        <Featured products={allProducts} />
      </div>

      <div className="animate-section">
        <Categories />
      </div>

      <div className="animate-section">
        <Promo />
      </div>

      <div className="animate-section">
        <Feed />
      </div>

      <Footer />
    </>
  );
};

export default Home;
